<template>
  <v-dialog
    v-model="dialog"
    max-width="350"
    persistent
  >
    <v-card>
      <v-card-title class="text-h6">
        Şifrenizi Değiştirin
      </v-card-title>

      <v-card-text>
        <p>
          Aynı şifreyi uzun süredir kullanıyorsunuz. Lütfen güvenlik amacıyla şifrenizi değiştirin.
        </p>
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="changePassword"
        >

          <v-text-field
            v-model="userSettings.password"
            label="Yeni Şifreniz"
            :rules="[val => !!val || 'Bu alanı doldurun.']"
            :append-icon="
                  showPass ? 'visibility' : 'visibility_off'
                "
            :type="showPass ? 'text' : 'password'"
            @click:append="showPass = !showPass"
          >
          </v-text-field>

          <v-text-field
            v-model="userSettings.password_confirmation"
            label="Yeni Şifreniz Tekrar"
            :rules="confirmPassword"
            :append-icon="
                  showPassConf ? 'visibility' : 'visibility_off'
                "
            :type="showPassConf ? 'text' : 'password'"
            @click:append="showPassConf = !showPassConf"
          >
          </v-text-field>

          <div class="d-flex justify-end mt-3">
            <v-btn
              type="submit"
              color="primary"
            >Kaydet</v-btn>
          </div>
        </v-form>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ChangePasswordDialog',
  data() {
    return {
      dialog: false,
      showPass: false,
      showPassConf: false,
      userSettings: {
        password: '',
        password_confirmation: '',
      },
    };
  },
  computed: {
    ...mapState(['user', 'is_customer_service']),
    confirmPassword() {
      return [
        val => !!val || 'Bu alanı doldurun.',
        val => val === this.userSettings.password
          || 'Girdiğiniz şifreler birbiriyle uyuşmuyor.'
          || this.$refs.form.reset(),
      ];
    },
  },
  created() {
    this.dialog = !this.user.password_changed && !this.is_customer_service;
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),

    changePassword() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.send({ route: 'forced/change/credentials', data: this.userSettings })
        .then((resp) => {
          if (resp.data.code !== 200) {
            throw new Error(resp);
          }

          this.user.password_changed = true;
          this.dialog = !this.user.password_changed;
          this.userSettings = {};
          this.$refs.form.reset();
        })
        .catch(err => console.log(err));
    },
  },
};
</script>
